import { BASE_URL, BASE_URL_TWO } from "./utils";

export const GET_EMPLOYEE_ALL_FOLDERS= `${BASE_URL_TWO}Default.aspx?sp=getEmployeesForFolderView`;
export const GET_EMPLOYEE_FAMILYMEMBERS_FOLDERS =`${BASE_URL_TWO}Default.aspx?sp=getEmployeeFamilyMembersForFolderView`
export const GET_ALL_EMPLOYEE_FILES =`${BASE_URL_TWO}Default.aspx?sp=getFamilyMembersFilesForFolderView`
export const GET_TMTD_DOCUMENTS= `${BASE_URL_TWO}Default.aspx?sp=getTDTMDocuments&pathToDisplay=`
export const GET_CAR_DOCUMENTS=`${BASE_URL_TWO}Default.aspx?sp=getVehicleDoc&pathToDisplay=`